<template>
    <div
        v-if="isScrollable"
        class="ds-table-scrollable-wrapper"
        :class="{ 'ds-table-scrollable-wrapper--responsive': isResponsive }"
    >
        <table class="ds-table" :class="{ 'ds-table--dark': theme === 'dark' }" :data-table-scrollable="isScrollable">
            <slot></slot>
        </table>
    </div>
    <table v-else class="ds-table" :class="{ 'ds-table--dark': theme === 'dark' }">
        <slot></slot>
    </table>
</template>

<script lang="ts" setup>
import type { Theme } from "../types/theme";

withDefaults(
    defineProps<{
        /**
         * Enable scrollable table (up to certain breakpoint)
         */
        isScrollable?: boolean;
        /**
         * Combine with isScrollable prop to have auto-scrollable content
         */
        isResponsive?: boolean;
        /**
         * Set theme
         */
        theme?: Theme;
    }>(),
    {
        isScrollable: false,
        isResponsive: false,
        theme: "light",
    }
);
</script>
